module.exports = __webpack_public_path__ + "static/media/53.f9aee841.wav";